import React, { Component, Fragment } from 'react'

import DocumentTableRow from '../DocumentTableRow'
import { TableHeader, HeaderItem } from './styles'

class DocumentTable extends Component {

  render() {
    const {
      headers,
      items,
      data,
      loading,
      error
    } = this.props

    return (
      <Fragment>
        <TableHeader>
          {headers.map((header, index) => {
            return <HeaderItem key={index}> {header}</HeaderItem>
          })}
        </TableHeader>

        {items.map(item => {
          return (
            <DocumentTableRow
              key={item.id}
              item={item}
              headers={headers}
              data={data}
              loading={loading}
              error={error}
            />
          )
        })}
      </Fragment>
    )
  }
}

export default DocumentTable



// WEBPACK FOOTER //
// ./src/components/DocumentTable/index.js